import React, { useState } from 'react';
import { Position } from 'reactflow';
import { Box, TextField, Typography } from '@mui/material';
import TagInput from '../Test/TagInput';
import InputHandle from '../UI/InputHandle/InputHandle';
import IconButtonTooltip from '../UI/IconButtonTooltip/IconButtonTooltip';
import { CaretDown, PlusCircle, Trash } from '@phosphor-icons/react';
import { isActiveEdge } from '../../util/findActiveHandle';
import useFlowsStore from '../../store/storeFlows';
import { useAuthStore } from '../../store/storeAuth';

type Props = {
  variables: {
    name: string;
    value: string;
    id: string;
  }[];
  addVariable: () => void;
  handleValueChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string,
  ) => void;
  formula: string;
  handleFormulaChange: (e: any) => void;
  data: any;
  edges: any;
  findColor: any;
};

const VariableEditor = ({
  variables,
  addVariable,
  handleValueChange,
  formula,
  handleFormulaChange,
  data,
  findColor,
  edges,
}: Props) => {
  const [collapsed, setCollapsed] = useState(false);
  const { setEdges, onEdgeDelete } = useFlowsStore(state => state);
  const onDeleteEdge = (sourceId: string) => {
    const test = edges?.filter(
      (edge: any) =>
        edge?.target === data?.myId && edge?.targetHandle === sourceId,
    );

    setEdges(eds => eds?.filter((edge: any) => edge?.id !== test[0]?.id));
    onEdgeDelete(test);
  };

  const { user } = useAuthStore(state => state);

  return (
    <Box>
      <TagInput
        placeholder="Enter a formula"
        isCollapsed={true}
        value={formula}
        dataConnected={data?.formulaData}
        name="formula"
        nodeId={data?.myId}
        labelName="Formula"
        disabled={isActiveEdge(edges, data?.myId, 'formula', 'target')}
        handleId="formula"
        onChange={handleFormulaChange}
        findColor={findColor}
        nodeLabel={data?.label}
        info="Shows the examples of all the functions that can be used in the formula."
        infoOnClick={() =>
          window.open('https://formulajs.info/functions', '_blank')
        }
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          position: 'relative',
          '& svg': { cursor: 'pointer' },
          mb: !collapsed ? 0 : '8px',
        }}
      >
        <CaretDown
          onClick={() => setCollapsed(!collapsed)}
          size={16}
          color={!collapsed ? '#3650DE' : '#667085'}
        />
        <Typography
          fontSize={'16px'}
          color={user?.theme === 'dark' ? '#D0D5DD' : '#101828'}
          fontWeight={600}
        >
          {'Advanced'}
        </Typography>
        {variables?.length < 5 && (
          <IconButtonTooltip title="Add " onClick={addVariable}>
            <PlusCircle size={16} color="#98A2B3" />
          </IconButtonTooltip>
        )}
      </Box>
      {(variables || [])?.map((variable, index) => (
        <Box
          style={{
            marginBottom: collapsed ? 20 : 0,
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            position: 'relative',
          }}
          key={variable.id}
        >
          {collapsed && (
            <>
              <TagInput
                placeholder="Variable Name"
                name="name"
                value={variable.name}
                isAdvanced={true}
                advancedCollapsed={collapsed}
                removeIcons={true}
                showCopy={false}
                removeCopyPreview={false}
                onChange={(e: React.ChangeEvent<any>) =>
                  handleValueChange(e, variable.id)
                }
                InputProps={{
                  style: {
                    color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
                  },
                }}
                sx={{
                  maxWidth: '150px',
                  color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
                  bgcolor: user?.theme === 'dark' ? '#1D2939' : '#F9FAFB',
                  border: `2px solid ${
                    user?.theme === 'dark' ? '#475467' : '#EAECF0'
                  }`,
                }}
              />

              <TagInput
                placeholder="Enter number or words"
                name="value"
                isAdvanced={true}
                advancedCollapsed={collapsed}
                removeIcons={true}
                showCopy={false}
                removeCopyPreview={false}
                value={variable.value}
                onChange={(e: React.ChangeEvent<any>) =>
                  handleValueChange(e, variable.id)
                }
                InputProps={{
                  style: {
                    color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
                  },
                }}
                sx={{
                  maxWidth: '150px',
                  color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
                  bgcolor: user?.theme === 'dark' ? '#1D2939' : '#F9FAFB',
                  border: `2px solid ${
                    user?.theme === 'dark' ? '#475467' : '#EAECF0'
                  }`,
                }}
              />

              {/* <IconButtonTooltip
                title="delete"
                onClick={() => {
                  handleFormulaChange({
                    target: {
                      name: 'variables',
                      value: variables?.filter(v => v?.id !== variable.id),
                    },
                  });

                  onDeleteEdge(variable.id);
                }}
              >
                <Trash size={16} color="#98A2B3" />
              </IconButtonTooltip> */}
            </>
          )}
          <InputHandle
            key={`${variable.id}`}
            position={Position.Left}
            type="target"
            left={-26}
            isActive={isActiveEdge(edges, data?.myId, variable.id, 'target')}
            activeColor={findColor?.color}
            top={!collapsed ? '-8px' : '50%'}
            handleId={variable.id}
          />
        </Box>
      ))}
    </Box>
  );
};

export default VariableEditor;
{
  /* <TextField
                type="text"
                placeholder="Variable Name"
                name="name"
                value={variable.name}
                onChange={(e: React.ChangeEvent<any>) =>
                  handleValueChange(e, variable.id)
                }
                InputProps={{
                  style: {
                    color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
                  },
                }}
                sx={{
                  maxWidth: '150px',
                  color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
                  bgcolor: user?.theme === 'dark' ? '#1D2939' : '#F9FAFB',
                  border: `2px solid ${
                    user?.theme === 'dark' ? '#475467' : '#EAECF0'
                  }`,
                }}
              /> */
}
{
  /* <TextField
                type="text"
                name="value"
                placeholder="Enter number or words"
                value={variable.value}
                onChange={(e: React.ChangeEvent<any>) =>
                  handleValueChange(e, variable.id)
                }
                InputProps={{
                  style: {
                    color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
                  },
                }}
                sx={{
                  maxWidth: '190px',
                  color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
                  bgcolor: user?.theme === 'dark' ? '#1D2939' : '#F9FAFB',
                  border: `2px solid ${
                    user?.theme === 'dark' ? '#475467' : '#EAECF0'
                  }`,
                }}
              /> */
}
